"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveExtendLutBytes = void 0;
const resolveExtendLutBytes = (context, accounts, args, programId) => 32 * args.addresses.length;
exports.resolveExtendLutBytes = resolveExtendLutBytes;
//# sourceMappingURL=resolvers.js.map